import type { MetricKey, ScaleConfig } from './types';

export const ANALYSIS_KEY_MAP: Record<MetricKey, string[]> = {
    temperature: ['warm3', 'warm2', 'warm1', 'neutral', 'cool1', 'cool2', 'cool3'],
    brightness: ['light2', 'light1', 'medium', 'dark1', 'dark2'],
    saturation: ['weak2', 'weak1', 'medium', 'strong1', 'strong2'],
    transparency: ['clear2', 'clear1', 'medium', 'opaque1', 'opaque2'],
};

export const SCALE_CONFIGS: ScaleConfig[] = [
    {
        metric: 'temperature',
        title: '온도감',
        defaultKey: 'neutral',
        points: [
            { key: 'warm3', color: '#FF7429', label: '따뜻한' },
            { key: 'warm2', color: '#ff4f2f' },
            { key: 'warm1', color: '#ff655f' },
            { key: 'neutral', color: '#ff2f67', label: '뉴트럴' },
            { key: 'cool1', color: '#eb4b95' },
            { key: 'cool2', color: '#dc4ec3' },
            { key: 'cool3', color: '#b44cff', label: '차가운' },
        ],
    },
    {
        metric: 'saturation',
        title: '채도',
        defaultKey: 'medium',
        points: [
            { key: 'weak2', color: '#b7c8bf', label: '은은한' },
            { key: 'weak1', color: '#8bcfaa' },
            { key: 'medium', color: '#6edda1' },
            { key: 'strong1', color: '#37da7c' },
            { key: 'strong2', color: '#11d75e', label: '쨍한' },
        ],
    },
    {
        metric: 'brightness',
        title: '명도',
        defaultKey: 'medium',
        points: [
            { key: 'light2', color: '#e7ea72', label: '밝은' },
            { key: 'light1', color: '#9e9a8a' },
            { key: 'medium', color: '#4a3f93' },
            { key: 'dark1', color: '#2f238f' },
            { key: 'dark2', color: '#37239a', label: '어두운' },
        ],
    },
    {
        metric: 'transparency',
        title: '탁도',
        defaultKey: 'medium',
        points: [
            { key: 'clear2', color: '#8edbe6', label: '맑은' },
            { key: 'clear1', color: '#96c9dd' },
            { key: 'medium', color: '#a7aec8' },
            { key: 'opaque1', color: '#a8a4c3' },
            { key: 'opaque2', color: '#aaa7c1', label: '탁한' },
        ],
    },
];
